import React, { useState } from "react";

function InfoModel() {
    const [page, setPage] = useState(1);

    const handleNext = () => {
        if (page < 3) setPage(page + 1);
    };

    const handlePrev = () => {
        if (page > 1) setPage(page - 1);
    };

    return (
        <div className="info-detail">
            <p className="info-title">사용법</p>
            <div className="video-container">
                {page === 1 && (
                    <video src="/1page.mp4" controls autoPlay loop muted width="1000" />
                )}
                {page === 2 && (
                    <div className="info-news-container">
                        <>
                            <div className="info-c-container">
                                <img className="info-news-detail" src="/crawling.png" alt="크롤링"/>
                                <p className="info-model-detail">
                                    NewSnake는 자체 개발한 뉴스 크롤러로, 네이버와 다음의 주요 뉴스 기사를 자동으로 수집합니다.
                                    이를 통해 실시간으로 다양한 분야의 뉴스 데이터를 확보하고,
                                    이후 Gemini API 기반의 분석 과정에서 기업 연관도, 감성 분석, 키워드 추출 등에 활용할 수 있습니다.
                                </p>
                            </div>

                            <div className="info-c-container">
                                <img className="info-news-detail" src="/summary.png" alt="요약"/>
                                <p className="info-model-detail">
                                    NewSnake는 gogamza/kobart-summarization 모델을 활용하여 뉴스 기사를 분석합니다.
                                    이를 통해 각 뉴스의 제목, 관련 이미지, 본문 내용, 발행 날짜 등의 핵심 정보를 체계적으로 수집하고 정리할 수 있습니다.
                                </p>
                            </div>

                            <div className="info-c-container">
                                <img className="info-news-detail" src="/keyword.png" alt="키워드"/>
                                <p className="info-model-detail">
                                    NewSnake는 skt/kobert-base-v1 모델을 활용하여 뉴스 기사와 같은 텍스트 데이터에서 핵심 키워드를 추출합니다.
                                    추출된 키워드는 이후 연관 정보 분석과 분석 과정에서 활용됩니다.
                                </p>
                            </div>

                            <div className="info-c-container">
                                <img className="info-news-detail" src="/company.png" alt="회사"/>
                                <p className="info-model-detail">
                                    NewSnake는 Gemini API를 활용해 웹에서 크롤링한 뉴스 데이터를 분석한 후,
                                    자연어 처리 기반의 문맥 분석을 통해 뉴스 내용과 높은 연관성을 가진 기업을 자동으로 추출합니다.
                                </p>
                            </div>

                            <div className="info-c-container">
                                <img className="info-news-detail" src="/123.png" alt="감정분석"/>
                                <p className="info-model-detail">
                                    NewSnake는 snunlp/KR-FinBert-SC 모델을 활용하여 뉴스 본문 내용을 분석하고,
                                    해당 내용이 긍정적인지, 중립인지, 혹은 부정적인지 감성적으로 평가합니다.
                                    이를 통해 뉴스의 전반적인 정서적 경향을 이해하고, 주가 변동 예측이나 투자 의사 결정과 같은 후속 분석에 활용할 수 있습니다.
                                </p>
                            </div>
                        </>
                    </div>
                )}
                {page === 3 && (
                    <div className="info-news-container">
                        <>
                            <div className="info-c-container">
                                <img className="info-news-detail" src="/1212.png" alt="감정분석"/>
                                <p className="info-model-detail">
                                    NewSnake는 뉴스로부터 추출된 핵심 키워드와 실제 주가 데이터를 멀티모달 방식으로 연결하여 학습하고,
                                    이를 기반으로 향후 주가를 예측합니다.
                                </p>
                            </div>

                            <div className="info-c-container">
                                <img className="info-news-detail" src="/chart.png" alt="감정분석"/>
                                <p className="info-model-detail">
                                    NewSnake는 FinanceDataReader 라이브러리를 활용하여 다양한 국내외 기업의 주가 데이터를 자동으로 수집하고,
                                    이를 기반으로 주가 변동 추세를 분석합니다.
                                </p>
                            </div>
                        </>
                    </div>
                )}

                {/* 좌우 버튼 */}
                {page > 1 && (
                    <button className="info-page left" onClick={handlePrev}>
                        <img className="info-use-img" src="/left.png" alt="이전" />
                    </button>
                )}
                {page < 3 && (
                    <button className="info-page right" onClick={handleNext}>
                        <img className="info-use-img" src="/right.png" alt="다음" />
                    </button>
                )}
            </div>
            <div className="info-subdetail">
                {page === 1 && (
                    <p>네이버나 다음 뉴스의 주소(URL)를 검색창에 입력한 뒤 실행하세요.<br/>
                        약 1분 후, 해당 뉴스의 요약 결과 화면으로 자동 이동합니다.</p>
                )}
            </div>
        </div>
    );
}

export default InfoModel;